<template>
  <div class="flex flex-col">
    <h2 class="mx-auto mb-8">{{ $t("the-process") }}</h2>
    <Splide class="pb-9" :has-track="false" :options="options" :aria-label="$t('our-newest-products')">
      <SplideTrack>
        <SplideSlide
          v-for="(step, index) in props.processSteps?.processSteps?.data?.attributes?.process_steps"
          :key="JSON.stringify(step)"
        >
          <StepperProcessCard
            :step="step"
            :index="index"
            :totalSteps="props.processSteps?.processSteps?.data?.attributes?.process_steps?.length"
          />
        </SplideSlide>
      </SplideTrack>
      <div class="splide__arrows">
        <button class="splide__arrow--prev -px-[100px] absolute top-[25%]">
          <svg width="94" height="25" viewBox="0 0 94 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 24H90.5L61 1" stroke="black" stroke-width="2" />
          </svg>
        </button>
        <button class="splide__arrow--next -px-[100px] absolute top-[25%]">
          <svg width="94" height="25" viewBox="0 0 94 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 24H90.5L61 1" stroke="black" stroke-width="2" />
          </svg>
        </button>
      </div>
    </Splide>
  </div>
</template>
<script lang="ts" setup>
import { Splide, SplideSlide, SplideTrack } from "@splidejs/vue-splide";
import { ProcessStepsFragment } from "#gql";
import "@splidejs/vue-splide/css";
const { t: $t } = useI18n();

const props = defineProps<{
  processSteps: ProcessStepsFragment | null | undefined;
}>();

const options = {
  type: "slider",
  perPage: 1,
  gap: "24px",
  padding: "28%",
  pagination: true,
  arrows: false,
};
</script>
<style lang="scss" scoped>
:deep(.splide__pagination__page.is-active) {
  background: black;
  transform: none;
  z-index: 1;
}
:deep(.splide__arrow--prev) {
  left: -6em;
}
:deep(.splide__arrow--next) {
  right: -6em;
}
</style>
